export default {
  namespaced: true,
  state: {
    phoneModel: null || localStorage.getItem("phoneModel"),
    refreshField: false,
    isTabbar:true,
  },
  getters: {
    phoneModel: state => state.phoneModel,
    isHOM: state => state.phoneModel == "HOM",
    isAndroid: state => state.phoneModel == "Android",
    isIOS: state => state.phoneModel == "IOS",
    refreshField: state => state.refreshField,
    isTabbar:state=>state.isTabbar,
  },
  mutations: {
    // 设置系统信息
    setPhoneModel(state, phoneModel) {
      console.log("phoneModel", phoneModel);
      state.phoneModel = phoneModel;
      localStorage.setItem("phoneModel", phoneModel);
    },
    changeRefreshField(state, refreshField) {
      state.refreshField = refreshField;
    },
    setIsTabbar(state,value){
      state.isTabbar = value;
    }
  },
  actions: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js